/** @jsx jsx */

import { Fragment as _, memo, useContext } from 'react';
import { jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import Flipcards_v2 from './Flipcards_v2';
import Flipcard_v2 from './Flipcard_v2';
import renderBlock from 'services/apiHelpers/renderBlock';
import {
  Row,
  Column,
  SingleColumnLayout,
  TwoColumnLayout,
} from 'components/UI/ColumnAndRow';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import Media, { MediaContext, IMediaContext } from 'components/lib/Media';
import { interactionContext as InteractionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import getBlockById from 'services/apiHelpers/getBlockById';
import continueBtn from '../ContinueBtn/continueBtn_v2';
import { Block } from 'factories/block';
import shouldUpdate from 'services/shouldUpdate';
import Embed from 'components/lib/Embed';
import PDF from 'components/lib/PDF';
import { OpenPDF } from 'components/lib/PDF/OpenPDF';
import imagePlaceholder from 'assets/Square.png';
import { imgPlaceholders } from 'components/lib/Image';
import { ImageContext } from 'components/lib/Image';
import placeholderImage from 'assets/Square.svg';
import longRectangle from 'assets/Long Rectangle.svg';
import EditableBtn from 'components/lib/EditableBtn';

const Components = {
  Row,
  Column,
  ////
  //// existing modules styled to expect centered text. will break if ! className: 'flipcard-text'
  Text: ({ children, ...props }) => {
    return (
      <EditableText
        {...{
          ...props,
          className: 'flipcard-text',
        }}
      />
    );
  },
  InteractionColumn: ({ children, ...props }) => {
    const interactionContext = useContext(InteractionContext);
    const { includeAdditionalTextField } = interactionContext.props;

    const [flipcards, txt] = children;

    if (!includeAdditionalTextField) {
      return flipcards;
    }

    return (
      <_>
        {flipcards}
        <div
          style={{
            margin: '20px 0 0 0',
          }}
        >
          {txt}
        </div>
      </_>
    );
  },

  Flipcards: Flipcards_v2,
  Flipcard({ children, ...props }) {
    return (
      <ImageContext.Provider
        value={{
          editWrapperType: 1,
          placeholder: placeholderImage || imagePlaceholder,
          //
          canUpdateContainerHeight: false,
        }}
      >
        <Flipcard_v2 {...props}>{children}</Flipcard_v2>
      </ImageContext.Provider>
    );
  },
  FlipcardSide: ({ children }) => children,
  Front: ({ children }) => children,
  Back: ({ children }) => children,

  Image: ({ children, ...props }) => {
    const mediaContext = useContext(MediaContext) as IMediaContext;

    return (
      <Image
        {...{
          ...props,

          placeholder: longRectangle || imgPlaceholders[1],
        }}
      />
    );
  },

  Video,
  Audio,
  // these can return null
  Transcript: () => null,
  EditableButton: EditableBtn,
  //
  SVG: ({ children, ...props }) => (
    /* @ts-ignore */
    <SVG {...{ ...props, editWrapperType: 1 }} />
  ),
  Embed,
  Media,
  TwoColumnLayout,
  SingleColumnLayout,
  ContinueButton: continueBtn,
  PDF,
  OpenPDF,
};

const FlipCardDisplay = memo((props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <InteractionContext.Provider
        value={{ ...interactionBlock, updateItemsSeen: null }}
      >
        {(interactionBlock.children as Block[]).map((child) => {
          return renderBlock(child, Components);
        })}
      </InteractionContext.Provider>
    </Container>
  );
}, shouldUpdate as any);

export default FlipCardDisplay;
